import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const SkinConcerns = lazyWithPreload(() => import('./SkinConcerns'))
export const LikeChatSkinConcerns = lazyWithPreload(
  () => import('./LikeChatSkinConcerns'),
)
export const SkinConcernsVariant2 = lazyWithPreload(
  () => import('./SkinConcernsVariant2'),
)
export const SkinConcernsVariant4 = lazyWithPreload(
  () => import('./SkinConcernsVariant4'),
)
